var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-popover",
    {
      attrs: {
        placement: "top",
        "boundaries-element": "viewport",
        delay: { hide: 100 },
        trigger: "hover",
      },
      scopedSlots: _vm._u([
        {
          key: "popover",
          fn: function () {
            return [
              _c("div", { staticClass: "p-2" }, [
                _c("h5", { staticClass: "bold mb-2 text-grey" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("application.messages.consentTooltip.title")
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "font-weight-normal text-grey" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "application.messages.consentTooltip.paragraph-1"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "font-weight-normal text-grey" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(
                          "application.messages.consentTooltip.paragraph-2"
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "tooltip-target" },
        [
          _vm._t("default", function () {
            return [
              _c(
                "span",
                {
                  staticClass:
                    "mx-1 clickable text-primary consent-status-tooltip",
                },
                [
                  _c("i", {
                    staticClass: "fa fa-info-circle",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }